<i18n src="./../../i18n/cart_summary_form.json"></i18n>

<template>
    <div>
        <div class="row p-0 m-0 mt-checkout no-gutters mt-3 pb-0">
            <div class="col-12 p-4">
                <div class="row">
                    <div class="col">
                        <p class="mb-0" v-text="$t('price')" />
                    </div>
                    <div class="col-auto">
                        <p class="mb-0 font-weight-bold" v-text="getSummaryRentalPrice() + ' ' + currencyShort"/>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <p class="mb-0" v-text="$t('additionalServices')" />
                    </div>
                    <div class="col-auto">
                        <p class="mb-0 font-weight-bold" v-text="getSummaryVasPrice() + ' ' + currencyShort"/>
                    </div>
                </div>

                <hr class="mt-4 mb-4">

                <div class="row">
                    <div class="col">
                        <p class="mb-0" v-text="$t('total')" />
                    </div>
                    <div class="col-auto">
                        <p class="mb-0 font-weight-bold" v-text="getSummaryPrice() + ' ' + currencyShort"/>
                    </div>
                </div>
                <div class="row mb-4">
                    <div class="col">
                        <p class="mb-0" v-text="$t('tax')" />
                    </div>
                    <div class="col-auto">
                        <p class="mb-0 font-weight-bold" v-text="getTaxPrice() + ' ' + currencyShort"/>
                    </div>
                </div>

                <button v-if="!canPay" type="button" class="btn btn-primary mt-product-btn mt-btn-labeled mt-button mt-button-primary p-3 w-100 font-weight-bold" v-text="$t('sendRequest')" v-on:click="sendRequest()"></button>
                <button v-if="canPay" type="button" class="btn btn-primary mt-product-btn mt-btn-labeled mt-button mt-button-primary p-3 w-100 font-weight-bold" v-text="$t('orderAndPay')" v-on:click="orderAndPay()"></button>
                <button v-if="canPay" class="mt-2 button--add-to-cart button button--primary js-form-submit form-submit btn btn-primary p-3 w-100 font-weight-bold mt-c-blue-light" v-text="$t('orSendRequest')" v-on:click="sendRequest()"></button>

                <p class="font-weight-lighter mt-fs-small mt-4 mb-0"><u><router-link :to="{name: 'priceCalculation'}" v-text="$t('howCalculatePrice')" /></u></p>
            </div>
        </div>
        <div v-if="canPay" class="row p-0 m-0 mt-checkout no-gutters mt-3 pb-0">
            <div class="col-12 p-4">
                <div class="row">
                    <div class="col">
                        <p class="font-weight-bold mt-fs-x-large pt-4">{{ $t('overpaymentInfo') }}
                            <span class="info-icon">i
                                <span class="tooltip mt-c-grey" v-text="$t('overpaymentInfoTooltip')" />
                            </span>
                        </p>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <p class="mb-0 mt-4" v-text="$t('competitorsInfo')" />
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <p class="mb-0 text-danger font-weight-bold" v-text="$t('fourWeeksPrice')" />
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <p class="mb-0 mt-4" v-text="$t('ourPrice')" />
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <p class="mb-0 text-success font-weight-bold" v-text="$t('oneWeekPrice')" />
                    </div>
                </div>
            </div>

        </div>
    </div>

</template>

<script>

    import {mapGetters} from "vuex";
    import {Const} from "@/main";

    export default {
        name: "CartSummaryForm",
        components: {},
        props: {
            products: {},
            deliveryForm: {},
        },
        data () {
            return {
                locale: this.$i18n.locale,
                currencyShort: Const.PRIMARY_CURRENCY_SHORT,
                canPay: false
            }
        },
        computed: {
            ...mapGetters(['getCart']),
        },
        mounted() {
            if (this.getCart.length > 0) {
                let availableItems = 0;
                for (let position = 0; position < this.getCart.length; position++) {
                    if (this.getCart[position].canBuy) {
                        availableItems++
                    }
                }
                if (Const.PRIMARY_LOCALE === 'pl' && availableItems === this.getCart.length) {
                    this.canPay = true
                }
            }
        },
        methods: {
            getSummaryRentalPrice() {
                if (!this.canPay || this.deliveryForm.startDate === null || this.deliveryForm.endDate === null || this.deliveryForm.startDate === '' || this.deliveryForm.endDate === '') {
                    return '-'
                }
                const calcStartDate = this.parseDate(this.deliveryForm.startDate)
                const calcEndDate = this.parseDate(this.deliveryForm.endDate)
                const period = this.calculatePeriod(calcStartDate, calcEndDate)

                var scalar = 1
                if (period > 28) {
                    scalar = Math.ceil(period / 7) / 4
                }

                let price = 0;
                for (let position = 0; position < this.getCart.length; position++)  {
                    if (this.getCart[position].canBuy) {
                        price += this.getCart[position].quantity * this.getVariationWithId(this.getCart[position].possibleVariations, this.getCart[position].variation).grossPrice * scalar
                    }
                }

                return (Math.round(price * 100) / 100).toFixed(2)
            },
            getVariationWithId(possibleVariations, id) {
                let variation = possibleVariations.filter(variation => String(variation.id) === String(id))
                if (variation.length > 0) {
                    return variation[0]
                }
            },
            parseDate(date) {
                var dateStr = date.toString().replace(/\D/g,'')
                return new Date(
                    Number(dateStr.substr(4, 4)),
                    Number(dateStr.substr(2, 2)) - 1,
                    Number(dateStr.substr(0, 2)),
                )
            },
            calculatePeriod(startDate, endDate) {
                return Math.round((endDate.getTime() - startDate.getTime()) / 86400000)
            },
            getSummaryVasPrice() {
                if (!this.canPay || this.deliveryForm.startDate === null || this.deliveryForm.endDate === null || this.deliveryForm.startDate === '' || this.deliveryForm.endDate === '') {
                    return '-'
                }

                const calcStartDate = this.parseDate(this.deliveryForm.startDate)
                const calcEndDate = this.parseDate(this.deliveryForm.endDate)
                const period = this.calculatePeriod(calcStartDate, calcEndDate)

                var scalar = 1
                if (period > 28) {
                    scalar = Math.ceil(period / 7) / 4
                }
                let price = 0;
                for (let position in this.getCart) {
                    if (this.getCart[position].canBuy) {
                        for (let additionalServicePosition in this.getCart[position].availableAdditionalServices) {
                            if (this.getCart[position].availableAdditionalServices[additionalServicePosition].selected) {
                                if (this.getCart[position].availableAdditionalServices[additionalServicePosition].serviceType === 'RECURRING_FEE') {
                                    price += this.getCart[position].quantity * this.getCart[position].availableAdditionalServices[additionalServicePosition].grossPrice * scalar * 4
                                } else if (this.getCart[position].availableAdditionalServices[additionalServicePosition].serviceType === 'ONE_TIME_FEE') {
                                    price += this.getCart[position].quantity * this.getCart[position].availableAdditionalServices[additionalServicePosition].grossPrice
                                }
                            }
                        }
                    }
                }

                return (Math.round(price * 100) / 100).toFixed(2)
            },
            getSummaryPrice() {
                if (!this.canPay || this.deliveryForm.startDate === null || this.deliveryForm.endDate === null || this.deliveryForm.startDate === '' || this.deliveryForm.endDate === '') {
                    return '-'
                }
                return (Number(this.getSummaryRentalPrice()) + Number(this.getSummaryVasPrice())).toFixed(2)
            },
            getTaxPrice() {
                if (!this.canPay || this.deliveryForm.startDate === null || this.deliveryForm.endDate === null || this.deliveryForm.startDate === '' || this.deliveryForm.endDate === '') {
                    return '-'
                }

                const calcStartDate = this.parseDate(this.deliveryForm.startDate)
                const calcEndDate = this.parseDate(this.deliveryForm.endDate)
                const period = this.calculatePeriod(calcStartDate, calcEndDate)

                var scalar = 1
                if (period > 28) {
                    scalar = Math.ceil(period / 7) / 4
                }
                let price = 0;
                for (let position in this.getCart) {
                    if (this.getCart[position].canBuy) {
                        price += this.getCart[position].quantity * this.getVariationWithId(this.getCart[position].possibleVariations, this.getCart[position].variation).netPrice * scalar
                        for (let additionalServicePosition in this.getCart[position].availableAdditionalServices) {
                            if (this.getCart[position].availableAdditionalServices[additionalServicePosition].selected) {
                                if (this.getCart[position].availableAdditionalServices[additionalServicePosition].serviceType === 'RECURRING_FEE') {
                                    price += this.getCart[position].quantity * this.getCart[position].availableAdditionalServices[additionalServicePosition].netPrice * scalar * 4
                                } else if (this.getCart[position].availableAdditionalServices[additionalServicePosition].serviceType === 'ONE_TIME_FEE') {
                                    price += this.getCart[position].quantity * this.getCart[position].availableAdditionalServices[additionalServicePosition].netPrice
                                }
                            }
                        }
                    }
                }

                return (this.getSummaryPrice() - Math.round(price * 100) / 100).toFixed(2)
            },
            sendRequest() {
                this.$parent.sendRequest()
            },
            orderAndPay() {
                this.$parent.orderAndPay()
            }
        }
    }
</script>

<style scoped>
    .mt-checkout {
        background-color: #fff;
        padding-top: 1rem;
        border: 1px solid #e7e7e7;
    }

    .button--add-to-cart {
        background-color: #fff;
        width: 150px;
        border: solid 1px #4092e5;
        border-radius: 0;
        padding: .7rem 1.5rem;
        font-size: .9rem;
    }

    .button--add-to-cart:hover {
        color: #4092e5;
        background-color: #e5f3ff;
    }

    .info-icon {
        position: relative;
        font-size: 10px;
        background-color: #f1f1f1;
        border-radius: 50%;
        border: 1px solid #e2e2e2;
        width: 15px;
        height: 15px;
        display: inline-flex;
        justify-content: center;
        align-items: center;
        margin-left: 5px;
        cursor: pointer;
        top: -15px;
    }

    .info-icon:hover .tooltip {
        opacity: 1;
        visibility: visible;
    }

    .tooltip {
        position: absolute;
        left: 25px;
        top: -5px;
        background-color: white;
        border: 1px solid #e2e2e2;
        border-radius: 0px;
        padding: 8px;
        width: 123px;
        font-size: 12px;
        line-height: 1.4;
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
        opacity: 0;
        visibility: hidden;
        transition: opacity 0.2s ease, visibility 0.2s ease;
    }

    .mt-checkout a {
        color: #6c6c6c;
    }
</style>